<script>
    import { createEventDispatcher } from 'svelte';

    export let assets = [];
    export let showDropdown = false;

    const dispatch = createEventDispatcher();
</script>
<style>
    .fa-times {
        cursor: pointer;
    }
</style>
<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" class:show={showDropdown} style="right: -66.6%; max-width: 390px; width: 390px; top: -3px;">
    <div class="dropdown-header">Seleccionar activo
        <span class="float-end">
            <i class="fas fa-times" on:click|preventDefault={()=>dispatch("closeSearchPanel")}></i>
        </span>
    </div>
    {#each assets as asset}
        {#if !asset.url && !asset.name}
            <div class="dropdown-item" on:click|preventDefault={()=>dispatch("selectAsset", asset)}>{asset.ip_address + "/" + asset.protocol + "/" + (asset.port ? asset.port : "") }</div>
        {:else}
            <div class="dropdown-item" style="cursor: pointer;" on:click|preventDefault={()=>dispatch("selectAsset", asset)}>
                {asset.name || asset.url}
                {#if asset.url}
                    <span>(Puerto: {asset.port})</span>
                {/if}
            </div>
        {/if}
    {/each}

</div>
